// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"7444": "9e472bfc","7937": "6e0da792","9027": "304eaa0f","9039": "248da94a",}[chunkId] + ".css"
}